import { themeColor } from "../theme-helper";

export const timeline = {
  progress: {
    backgroundColor: themeColor("elements.hr"),
  },
  indicator: {
    backgroundColor: themeColor("variables._mainCTA"),
  },
  circle: {
    boxShadow: "0 0 0 8px",
    color: "background",
    backgroundColor: themeColor("variables._mainCTA"),
  },
  background: {
    backgroundColor: "background",
  },
  fade: {
    top: {
      backgroundImage:
        "linear-gradient(to bottom, var(--theme-ui-colors-background), rgba(255, 255, 255, 0))",
    },
    bottom: {
      backgroundImage:
        "linear-gradient(to top, var(--theme-ui-colors-background), rgba(255, 255, 255, 0))",
    },
  },
};
